export default theme => ({
  hexaSvg1: {
    position: 'absolute',
    top: -30,
    left: '60%',
  },
  hexaSvg2: {
    position: 'absolute',
    bottom: -30,
    left: '30%',
    zIndex: 30,
  },
  container: {
    backgroundColor: theme.palette.grey.main,
    color: theme.palette.grey.contrastText,
    paddingTop: theme.spacing(9),
    paddingBottom: theme.spacing(6),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(10),
    },
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(16),
    },
    [theme.breakpoints.up('lg')]: {
      paddingTop: theme.spacing(20),
    },
  },
  title: {
    textAlign: 'center',
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    paddingBottom: theme.spacing(4),
  },
  buttonBackContainer: {
    textAlign: 'center',
    paddingBottom: theme.spacing(8),
  },
  logoContainer: {
    display: 'block',
    position: 'absolute',
    cursor: 'pointer',
    left: theme.spacing(2),
    top: theme.spacing(2),
    width: 60,
    [theme.breakpoints.up('sm')]: {
      left: theme.spacing(3),
      top: theme.spacing(3),
      width: 80,
    },
    [theme.breakpoints.up('md')]: {
      width: 90,
      left: theme.spacing(12),
      top: theme.spacing(8),
    },
    [theme.breakpoints.up('lg')]: {
      width: 115,
      left: theme.spacing(18),
      top: theme.spacing(12),
    },
  },
  logo: {
    width: '100%',
  },
  hexaGrid: {
    paddingBottom: theme.spacing(6),
    [theme.breakpoints.down('md')]: {
      justifyContent: 'space-around',
    },
  },
  hexa: {
    color: theme.palette.grey.main,
    textAlign: 'center',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: 290,
    height: 290,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      width: 250,
      height: 250,
    },
  },
  hexaTitle: {
    fontWeight: 400,
  },
  hexaNum: {
    fontSize: '4rem',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  hexaButton: {
    marginTop: theme.spacing(2),
  },
  hexaNum1: {
    color: theme.palette.pink.main,
  },
  hexa1: {
    backgroundImage:
      'url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNTAuMjQgMTQxLjUzIj48dGl0bGU+aGV4YTE8L3RpdGxlPjxnIGlkPSJDYWxxdWVfMiIgZGF0YS1uYW1lPSJDYWxxdWUgMiI+PGcgaWQ9IkNhbHF1ZV8xLTIiIGRhdGEtbmFtZT0iQ2FscXVlIDEiPjxwYXRoIGQ9Ik0xMjEuODgsMTAuNTZsMjguMzYsNzAuNzYtNDYuNzcsNjAuMjFMMjguMzYsMTMxLDAsNjAuMjEsNDYuNzYsMFoiIGZpbGw9IiNmZmYiLz48L2c+PC9nPjwvc3ZnPg==")',
  },
  hexa2: {
    backgroundImage:
      'url("data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FscXVlXzEiIGRhdGEtbmFtZT0iQ2FscXVlIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE1MCAxNTAiPjx0aXRsZT5oZXhhMjwvdGl0bGU+PHBhdGggZD0iTTExMi42OCwxMGwzNy41Niw2NS4yMi0zNy41Niw2NS4yM0gzNy41NkwwLDc1LjIyLDM3LjU2LDEwWiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==")',
  },
  hexaNum2: {
    color: theme.palette.yellow.main,
  },
  hexa3: {
    backgroundImage:
      'url("data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FscXVlXzEiIGRhdGEtbmFtZT0iQ2FscXVlIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE1MCAxNTAiPjx0aXRsZT5oZXhhMzwvdGl0bGU+PHBhdGggZD0iTTEwMi42MSw0LDE1MC4xNiw2M2wtMjcsNzAuODctNzQuNTIsMTEuOEwxLjEyLDg2LjYzbDI3LTcwLjg3WiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==")',
  },
  hexaNum3: {
    color: theme.palette.blue.light,
  },
});
